/**
 * Array Chunking Utility
 */

/**
 * Splits an array into chunks of specified size.
 *
 * @param array - The array to split into chunks
 * @param chunkSize - The size of each chunk
 * @returns Array of arrays, each containing at most chunkSize elements
 *
 * @example
 * arrayChunk([1, 2, 3, 4, 5], 2) // [[1, 2], [3, 4], [5]]
 */
export const arrayChunk = <T>(array: T[], chunkSize: number): T[][] => {
  const result: T[][] = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    result.push(array.slice(i, i + chunkSize));
  }
  return result;
};
